import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NebulaOrders = React.lazy(() =>
    import('../NebulaOrders')
);
const nebulaOrdersRoutesRegistry = [
    {
        path: PAGE_URL.NEBULA_ORDERS_PAGE,
        element: <NebulaOrders />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default nebulaOrdersRoutesRegistry;
